import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";

export const Title = ({
    size = "lg",
    colour = "primary",
    weight = "semibold",
    children,
    ...textProps
}: BaseTextProps) => {
    return (
        <BaseText {...textProps} size={size} colour={colour} weight={weight}>
            {children}
        </BaseText>
    );
};
